import {
  DOCUMENT_AUDIT_TRAIL__FETCH_FAILURE,
  DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST,
  DOCUMENT_AUDIT_TRAIL__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAuditTrailAction } from '@app/store/document/auditTrailFile/actions';

type DocumentAuditTrailFileState = string | null;

const initialState: DocumentAuditTrailFileState = null;

export default function reducer(
  state: DocumentAuditTrailFileState = initialState,
  action: DocumentAuditTrailAction
) {
  switch (action.type) {
    case DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST:
      return initialState;
    case DOCUMENT_AUDIT_TRAIL__FETCH_SUCCESS:
      if (action.payload.url) {
        const { url } = action.payload;
        return url;
      }
      return initialState;
    case DOCUMENT_AUDIT_TRAIL__FETCH_FAILURE:
      return initialState;
    default:
      return state;
  }
}
